import PropTypes from 'prop-types'
import styled from 'astroturf/react'

import RadioButtonInput from './inputs/radio_button'
import _RadioButton from "RadioButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/form/radio_button.js?styleId=RadioButton";
import _Label from "radio_button-Label.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/form/radio_button.js?styleId=Label";


const RadioButton = /*#__PURE__*/styled(RadioButtonInput, null, {
  displayName: "RadioButton",
  styles: _RadioButton
})

const Label = /*#__PURE__*/styled('label', null, {
  displayName: "Label",
  styles: _Label
})

const RadioButtonField = ({ className = null, label = null, ...inputProps }) => (
  <div className={className}>
    <Label>
      <RadioButton {...inputProps} />
      <div>{label}</div>
    </Label>
  </div>
)

RadioButtonField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node
}

export default RadioButtonField
